'use client'

import { useLingui } from '@lingui/react'
import * as React from 'react'

import { InteractiveRobotSpline } from '@/components/blocks/interactive-3d-robot'
import { GridSection } from '@/components/marketing/fragments/grid-section'
import { BackgroundSection } from '@/components/ui/background-bee'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { StarBorder } from '@/components/ui/star-border'

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 }
  }
}

export function AboutUs(): React.JSX.Element {
  const { i18n } = useLingui()
  // const ROBOT_SCENE_URL = 'https://prod.spline.design/pvM5sSiYV2ivWraz/scene.splinecode'
  // const ROBOT_SCENE_URL = 'https://prod.spline.design/zrDbpTm6b8Xyml6n/scene.splinecode'
  // const ROBOT_SCENE_URL = 'https://prod.spline.design/8glM91b9bsfBLBim/scene.splinecode'
  const ROBOT_SCENE_URL = 'https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode'

  return (
    <GridSection>
      <section className='bg-diagonal-lines'>
        <BackgroundSection>
          <motion.div
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true }}
            variants={fadeIn}
            className='sm:container rounded-3xl'
          >
            <div className='grid gap-3 lg:grid-cols-2 lg:gap-3'>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className='space-y-4 p-6'
              >
                <div className='inline-block rounded-3xl bg-orange-400/10 px-3 py-1 text-sm'>
                  {i18n._('About us')}
                </div>
                <h2 className='text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl'>
                  Pione Group JSC
                </h2>
                <p className='text-muted-foreground'>
                  {i18n._(
                    'PIONE GROUP is a leading technology company in Vietnam, specializing in providing comprehensive Blockchain solutions applied in various fields such as agriculture, real estate, e-commerce, education, healthcare, finance, and more.'
                  )}
                </p>
                <p className='text-muted-foreground'>
                  {i18n._(
                    'We are customer-centric and continuously innovate to deliver high-quality products and services, aiming to become a leading technology corporation with global reach.'
                  )}
                </p>
                <StarBorder rounded='rounded-full' className='h-12 px-8 group'>
                  {i18n._('Learn more')}
                  <motion.span
                    initial={{ x: 0 }}
                    whileHover={{ x: 5 }}
                    transition={{ type: 'spring', stiffness: 400, damping: 10 }}
                  >
                    <ArrowRight className='ml-2 h-4 w-4 transition-transform group-hover:translate-x-1' />
                  </motion.span>
                </StarBorder>
              </motion.div>
              <div className='relative h-[350px] w-full md:h-[450px] lg:h-[500px] overflow-hidden rounded-3xl '>
                <InteractiveRobotSpline scene={ROBOT_SCENE_URL} className='absolute inset-0 z-0' />
              </div>
            </div>
          </motion.div>
        </BackgroundSection>
      </section>
    </GridSection>
  )
}
